import React from 'react';
import { FormSelect, MasterDetailForm } from '@digital/ui';

import { PostGestorTecnico } from '@app/api/sas/ordemCompra';
import { hasPermission } from '@app/helpers/permissions';
import { gestorOptionsState } from '../atoms';
import { useRecoilValue } from 'recoil';

interface Props {
  ordemCompraId: string;
  gestorAtualId: string;
  onUpdateDadosGerais: () => void;
  statusDisable: boolean;
}

const SelectIncluirGestorTecnico: React.FC<Props> = ({
  ordemCompraId,
  gestorAtualId,
  onUpdateDadosGerais,
  statusDisable,
}: Props) => {
  const gestorOptions = useRecoilValue(gestorOptionsState);

  const onSelected = (gestorTecnicoId: string) => {
    PostGestorTecnico({
      ordemCompraId: ordemCompraId,
      gestorTecnicoId: gestorTecnicoId,
    }).then(() => {
      onUpdateDadosGerais();
    });
  };

  return (
    <MasterDetailForm key="SelectIncluirGestorTecnicoForm" initialValues={{ gestorAtualId }}>
      <FormSelect
        options={gestorOptions}
        onSelect={(e: any) => onSelected(e)}
        name="gestorAtualId"
        label="Gestor Técnico"
        span={4}
        disabled={!hasPermission(['SAS_ALTERAR_GESTOR']) || !statusDisable}
        required
        showSearch
        filterOption={(input, item: any) => {
          return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
        }}
      />
    </MasterDetailForm>
  );
};

export default SelectIncluirGestorTecnico;
